import { Notification } from 'resources/types'
import { InAppBanner } from './InAppBanner'
import { useInAppBanner } from '../hooks/useInAppBanner'
import { ReactNode, useMemo } from 'react'
import { useLocation } from 'react-router-dom'

const DEFAULT_BLOCKED: (string | RegExp)[] = [
	'/settings/notifications/create',
	/^\/admin\//,
]

interface InAppBannerOutletProps {
	extraBlockedPaths?: (string | RegExp)[]
	renderAction?: (n: Notification) => ReactNode
}

export function InAppBannerOutlet({
	extraBlockedPaths = [],
	renderAction,
}: InAppBannerOutletProps) {

	const { pathname } = useLocation()

	const blockedPaths = useMemo(
		() => [...DEFAULT_BLOCKED, ...extraBlockedPaths],
		[extraBlockedPaths],
	)

	const { notification, markRead, dismiss, shouldBlockOnPath } = useInAppBanner({
		blockedPaths,
	})

	const path = pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '/')
	if (shouldBlockOnPath(path)) return null

	const onView = (n: Notification) => {
		// explicit-read
		void markRead(n)
	}

	const onDismiss = (n: Notification) => {
		// treat dismiss as “handled/read” + apply dismiss behavior
		void dismiss(n)
	}

	return (
		<InAppBanner
			notification={notification}
			onView={onView}
			onDismiss={onDismiss}
			renderAction={renderAction}
		/>
	)
}
